import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { Component, OnInit } from '@angular/core';
import { UserModel } from './../../models/user.model';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from './../../services/user.service';
import { AuthService } from 'src/app/services/auth.service';
import { ErrorHandlerService } from './../../services/error-handler.service';

@Component({
  selector: 'shc-hamburger-menu',
  templateUrl: './hamburger-menu.component.html',
  styleUrls: ['./hamburger-menu.component.scss'],
})
export class HamburgerMenuComponent implements OnInit {
  user: UserModel;
  isLoggedIn = false;
  constructor(
    private router: Router,
    private userService: UserService,
    private authService: AuthService,
    private modalCtrl: ModalController,
    private errorHandler: ErrorHandlerService,
    private translate: TranslateService
  ) {
  }

  ngOnInit() {
    this.authService.loggedIn.subscribe((loggedIn) => {
      this.isLoggedIn = loggedIn;
      if (loggedIn) {
        this.userService.get().subscribe(res => {
          console.log(res);
          this.user = res;
        });
      }
    });
  }

  // Voor een gast (niet ingelogd) stuurt dit item naar de inlogpagina i.p.v.
  // daadwerkelijk uit te loggen -- was voorheen onvoorwaardelijk "Uitloggen",
  // ook zichtbaar/klikbaar voor gasten (29 aug 2026).
  goToLogin() {
    this.modalCtrl.dismiss();
    this.router.navigate(['auth/login']);
  }

  routeToPage(path: string) {
    this.modalCtrl.dismiss();
    this.router.navigate([path]);
  }

  logout() {
    this.modalCtrl.dismiss();
    this.authService
      .logout()
      .subscribe(
        () => {
          this.translate.setDefaultLang('nl');
          this.translate.use('nl');
          this.router.navigate(['auth/login'], { replaceUrl: true });
        },
        error => this.errorHandler.handle(error)
      );
  }

}
